import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MobileMenu.css";

export default function MobileMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [aiLabOpen, setAiLabOpen] = useState(false);

  const close = () => {
    setOpen(false);
    setAiLabOpen(false);
  };

  const scrollTo = (id) => {
    close();
    navigate(`/?scrollTo=${id}`);
  };

  const goToAIPlatform = () => {
    close();
    navigate("/ai-platform");
  };

  return (
    <>
      <button
        className={`mobile-menu-toggle ${open ? "active" : ""}`}
        onClick={() => setOpen((v) => !v)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      {open && <div className="mobile-menu-overlay" onClick={close} />}

      <div className={`mobile-menu-panel ${open ? "open" : ""}`}>
        <ul className="mobile-menu-list">
          <li>
            <NavLink to="/" onClick={close}>
              {t("nav.home")}
            </NavLink>
          </li>
          <li>
            <button
              type="button"
              className="mobile-menu-section-btn"
              onClick={() => setAiLabOpen((v) => !v)}
            >
              {t("nav.aiLab")}
            </button>
            {aiLabOpen && (
              <ul className="mobile-menu-sub">
                <li>
                  <button onClick={goToAIPlatform}>
                    {t("nav.aiLabPlatform")}
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollTo("ai-lab")}>
                    {t("nav.specializedAi")}
                  </button>
                </li>
              </ul>
            )}
          </li>
          <li>
            <NavLink to="/Contact" onClick={close}>
              {t("nav.contact")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/AboutUs" onClick={close}>
              {t("nav.aboutUs")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/FAQ" onClick={close}>
              {t("nav.faq")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/Survey" onClick={close}>
              Survey
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}
